const BellIcon = ({ className }: { className: string }) => {
  return (
    (<svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-palette="BellIcon">
      <path
        d="M10.6667 8.91667H11.8334V10.0833H0.166687V8.91667H1.33335V4.83334C1.33335 2.25601 3.42269 0.166672 6.00002 0.166672C8.57736 0.166672 10.6667 2.25601 10.6667 4.83334V8.91667ZM9.50002 8.91667V4.83334C9.50002 2.90034 7.93301 1.33334 6.00002 1.33334C4.06702 1.33334 2.50002 2.90034 2.50002 4.83334V8.91667H9.50002ZM4.25002 11.25H7.75002V12.4167H4.25002V11.25Z"
        fill="currentColor"
      />
    </svg>)
  );
};

export default BellIcon;
